import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, ScannerCode, Breadcrumbs, Select, Card, Input, Subtitle, Collapsible } from '../../../../components/UI/ComponentsUI';
import { translate, showMessageToastCustom, downloadFile, isNullOrEmpty } from '../../../../utils/util';
import PickingService from '../../../../services/PickingService';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { ENUMS, VISIONS } from '../../../../utils/constants';
import ModalUpload from './ModalUpload';
import { getVision } from '../../../../services/auth';

const GenerateExpeditionCim = (props) => {
    const causalCostCenter = '585';
    const expeditionCim = props.location?.state?.expeditionCim;
    const [partNumber, setPartNumber] = useState({ mdr: '0086', mdrNumber: 1 });
    const [openModal, setOpenModal] = useState({ open: false, typeModal: "" })
    const [expedition, setExpedition] = useState({
        archivename: undefined,
        supplier: undefined,
        causal: undefined,
        cim: undefined,
        costCenter: undefined,
        status: ENUMS.eCimStatus.Available.value,
        partNumbers: [],
        cims: []
    });

    const onSubmit = () => {
        if (validateInputsRequired("formInput")) {
            let expeditionList = [];

            if (expedition.status === ENUMS.eCimStatus.Available.value) {
                expedition.status = ''
            }

            if (!expeditionCim) {
                expedition.cims.forEach(item => {
                    expeditionList.push({
                        ...expedition,
                        cim: item
                    })
                });

                expedition.partNumbers.forEach(item => {
                    expeditionList.push({
                        ...expedition,
                        ...item
                    })
                });
                props.generateSpreadsheet(expeditionList, (response) => {
                    downloadFile(response, `${expedition.archivename}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", true)
                })
            } else {
                props.generateExpeditionCim(expedition, () => {
                    showMessageToastCustom(translate('confirmed', 'general'), translate('sucess', 'general'), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');

                    setExpedition({
                        ...{
                            status: ENUMS.eCimStatus.Available.value,
                            partNumbers: [],
                            cims: []
                        }
                    });
                })
            }
        }
    }

    const onChange = (event) => {
        onValueChange(event, expedition, setExpedition);
    };

    const onChangePartNumber = (event) => {
        onValueChange(event, partNumber, setPartNumber);
    };

    const onChangeTotalQuantity = (event) => {
        partNumber.quantityPerMdr = event.target.value;
        onValueChange(event, partNumber, setPartNumber);
    };

    const addItem = (cim) => {
        if (!isNullOrEmpty(cim)) {
            cim = cim.padStart(10, '0').trim().replace(/\s+/g, '')
            if (expedition.cims.some((element) => element === cim)) {
                showMessageToastCustom(translate('warning', 'general'), "CIM já inserido!", 3000, 'mdi mdi-alert-circle-outline red-text');
            } else {
                expedition.cims.push(cim)
                expedition.cim = "";
                setExpedition({ ...expedition })
                document.getElementById('cim').focus();
            }
        }
    };

    const addpartNumber = () => {
        if (validateInputsRequired("partNumberInput")) {
            expedition.partNumbers.push(partNumber);
            setExpedition({ ...expedition });
            setPartNumber({ mdr: '0086', mdrNumber: 1 });
        }
    };

    const onChangeCim = (value) => {
        let newExpedition = { ...expedition };
        newExpedition.cim = value?.trim().replace(/\s+/g, '');

        if (!isNullOrEmpty(newExpedition.cim) && newExpedition.cim.length === 10) {
            addItem(newExpedition.cim);
        } else {
            setExpedition(newExpedition);
        }
    };

    const scanner = (value) => {
        addItem(value)
    };

    const scannerPartNumber = (value) => {
        if (!isNullOrEmpty(value)) {
            partNumber.partNumberCode = value.padStart(11, '0')
            setPartNumber({ ...partNumber })
        }
    };

    const handleSubtitle = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-file-table-outline", label: expeditionCim ? translate('expedition:picking.generate-expedition-cim') : translate('expedition:picking.generate-spreadsheet') }];
        return subtitlesItems;
    }

    const onChangeCausal = (value) => {
        let newExpedition = { ...expedition };
        newExpedition.causal = value;
        if (value !== causalCostCenter && document.getElementById('costcenter') !== null) {
            document.getElementById('costcenter').value = '';
            newExpedition.costCenter = undefined;
        }
        setExpedition(newExpedition)
    };

    const removeItem = (item) => {
        const findIndex = expedition.cims.indexOf(item)
        expedition.cims.splice(findIndex, 1);
        setExpedition({ ...expedition })
        document.getElementById('cim').focus();
    }

    const removePartNumber = (item) => {
        const findIndex = expedition.partNumbers.indexOf(item)
        expedition.partNumbers.splice(findIndex, 1);
        setExpedition({ ...expedition })
    }

    const insertListCims = (array) => {
        if (array && array.length > 0) {
            array.forEach((item) => {
                if (expedition.cims.some((element) => element === item)) {
                    showMessageToastCustom(translate('warning', 'general'), `CIM ${item} já inserido!`, 3000, 'mdi mdi-alert-circle-outline red-text');
                } else {
                    expedition.cims.push(item)
                }
            })

            setExpedition({ ...expedition })
        }
    }

    const insertListpartNumbers = (array) => {
        if (array && array.length > 0) {
            array.forEach((item) => {
                expedition.partNumbers.push({
                    partNumberCode: item.DESENHO,
                    mdr: "0086", // item.NRMDR,
                    totalQuantity: item.QTDETOTAL,
                    mdrNumber: 1, //item.QTDETOTAL,
                    quantityPerMdr: item.QTDETOTAL // item.TIPOMDR
                });
            })

            setExpedition({ ...expedition })
        }
    }

    const onChangeModal = (open, type) => {
        openModal.open = open;
        openModal.typeModal = type
        setOpenModal({ ...openModal })
    }

    return (
        <div>
            <Breadcrumbs title={{ icon: "mdi mdi-dolly", label: translate('expedition:picking.title') }} subtitles={handleSubtitle()} />
            {/* <div className="container-fluid h-65 mt-25" /> */}
            <div className="container" style={{ marginTop: '34px' }}>
                <Card>
                    <div id="formInput" className="row">
                        <div className="input-field no-padding col s6">
                            <Input
                                id="archivename"
                                name="archivename"
                                label={translate('expedition:picking.archive-name')}
                                type="text"
                                required={!expeditionCim}
                                value={expedition.archivename || ''}
                                onChange={onChange}
                            />
                        </div>
                        <div className="input-field no-padding col s5">
                            <Input
                                id="supplier"
                                name="supplier"
                                required
                                label="Cliente"
                                type="text"
                                numericonly="true"
                                maxLength="7"
                                value={expedition.supplier || ''}
                                onChange={onChange}
                            />
                        </div>
                        <div className="input-field no-padding col s4">
                            <Input
                                id="costCenter"
                                name="costCenter"
                                label={translate('expedition:picking.cost-center')}
                                type="text"
                                value={expedition.costCenter || ''}
                                onChange={onChange}
                                disabled={expedition.causal !== causalCostCenter}
                            />
                        </div>
                        <div className="input-field no-padding col s3">
                            <Input
                                id="causal"
                                name="causal"
                                required
                                label={translate('expedition:picking.movementType')}
                                type="text"
                                numericonly="true"
                                maxLength="3"
                                value={expedition.causal || ''}
                                onChange={(event) => onChangeCausal(event.target.value)}
                            />
                        </div>
                        <div className="col s4 no-padding">
                            <div className="input-field">
                                <Select
                                    required
                                    id="status"
                                    name="status"
                                    placeHolder={translate('general:status')}
                                    data={[
                                        { id: ENUMS.eCimStatus.Available.value, text: translate(ENUMS.eCimStatus.Available.text, 'general') },
                                        { id: ENUMS.eCimStatus.Wipexp.value, text: ENUMS.eCimStatus.Wipexp.text }]}
                                    change={onChange}
                                    defaultValue={expedition?.status}
                                />
                            </div>
                        </div>
                    </div>
                </Card>
                {/* CIM´s */}
                <Collapsible
                    id="collapsibleCim"
                    header='CIM´s'
                    body={
                        <>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <div className="input-field no-padding col s6">
                                    <ScannerCode onScanner={scanner} />
                                    <Input
                                        label={translate('expedition:picking.cim')}
                                        id="cim"
                                        name="cim"
                                        type="text"
                                        numericonly="true"
                                        maxLength="10"
                                        value={expedition.cim || ''}
                                        onChange={(event) => onChangeCim(event.target.value)}
                                    />
                                </div>
                                <div className="col s5" style={{ paddingTop: '10px' }}>
                                    <button
                                        className="btn-floating btn-small btn-principal waves-effect waves-light"
                                        type="button"
                                        onClick={() => addItem(expedition.cim)}
                                    >
                                        <i className={`mdi mdi mdi-plus`} />
                                    </button>
                                    <>  </>
                                    <button
                                        className="btn-floating btn-small btn-principal waves-effect waves-light"
                                        type="button"
                                        onClick={() => onChangeModal(true, "CIM")}
                                    >
                                        <i className="Small material-icons">cloud_upload</i>
                                    </button>
                                </div>
                            </div>
                            {expedition.cims.length > 0 &&
                                <div style={{ display: 'flex', flex: 1, flexWrap: 'wrap' }}>
                                    {expedition.cims.map((item, index) => (
                                        <div key={index} style={{ alignItems: 'center', padding: 4, margin: 2, border: 'solid', borderWidth: 1, width: 'auto', borderRadius: 6 }}>
                                            <i className={'mdi mdi-close-circle-outline posfix'} style={{ top: '0rem', fontSize: 20 }} onClick={() => removeItem(item)} />
                                            <span style={{ marginLeft: 6 }}>{item}</span>
                                        </div>
                                    ))}
                                </div>
                            }
                        </>
                    }
                />
                {/* PartNumber */}
                {
                    getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD &&
                    <Collapsible
                        id="collapsiblePartNumber"
                        close="true"
                        paddingbody="0.5rem"
                        header='Material Make e PAB'
                        body={
                            <>
                                <div id="partNumberInput" className="row" style={{ paddingTop: '10px' }}>
                                    <div className="input-field no-padding col s5">
                                        <ScannerCode onScanner={scannerPartNumber} />
                                        <Input
                                            required
                                            type="text"
                                            label={translate('physical-confirmation:part-number')}
                                            id="partNumberCode"
                                            name="partNumberCode"
                                            onChange={onChangePartNumber}
                                            numericonly="true"
                                            value={partNumber?.partNumberCode || ''}
                                            leadingzeros={11}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s3">
                                        <Input
                                            label="Qtd Total"
                                            id="totalQuantity"
                                            name="totalQuantity"
                                            type="number"
                                            required
                                            onChange={onChangeTotalQuantity}
                                            value={partNumber?.totalQuantity || ''}
                                        />
                                    </div>
                                    <div className="col s3" style={{ paddingTop: '10px', display: 'flex', gap: '1px', flexWrap: 'nowrap' }}>
                                        <button
                                            className="btn-floating btn-small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={() => addpartNumber()}
                                        >
                                            <i className={`mdi mdi mdi-plus`} />
                                        </button>
                                        <button
                                            className="btn-floating btn-small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={() => onChangeModal(true, "PARTNUMBER")}
                                        >
                                            <i className="Small material-icons">cloud_upload</i>
                                        </button>
                                    </div>
                                </div>
                                {expedition.partNumbers.length > 0 &&
                                    <div style={{ display: 'flex', flex: 1, flexWrap: 'wrap' }}>
                                        {expedition.partNumbers?.map((item, index) => (
                                            <div key={index} style={{ display: 'flex', alignItems: 'center', padding: 4, margin: 2, border: 'solid', borderWidth: 1, width: 'auto', borderRadius: 6 }}>
                                                <i className={'mdi mdi-close-circle-outline posfix'}
                                                    style={{ top: '0rem', fontSize: 20 }}
                                                    onClick={() => removePartNumber(item)} />
                                                <span style={{ marginLeft: 6 }}>
                                                    {item.partNumberCode} - {item.totalQuantity}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                }
                            </>
                        }
                    />
                }

                {(expedition.cims.length > 0 || expedition.partNumbers.length > 0) &&
                    <div className="row">
                        <div className="col s12" style={{ paddingBlockEnd: '10px' }}>
                            <Button
                                full="true"
                                className="col s6 btn-principal"
                                text={expeditionCim ? "Gerar Expedição" : translate('expedition:picking.generate-spreadsheet')}
                                onClick={onSubmit}
                            />
                        </div>
                    </div>
                }
            </div>
            <ModalUpload
                open={openModal.open}
                typeModal={openModal.typeModal}
                id="ModalUpload"
                callback={(data) => { openModal.typeModal === "CIM" ? insertListCims(data) : insertListpartNumbers(data) }}
                onCancel={() => onChangeModal(false, "")}
                onClose={() => onChangeModal(false, "")}
                onConfirm={() => onChangeModal(false, "")}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        generateSpreadsheet: (expeditionList, callback) => {
            dispatch(PickingService.generateSpreadsheet(expeditionList, callback));
        },
        generateExpeditionCim: (expeditionList, callback) => {
            dispatch(PickingService.generateExpeditionCim(expeditionList, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GenerateExpeditionCim));